module.exports = __webpack_public_path__ + "static/media/GooglePlayWhite.3a5beec7.png";